import { ILateralLengthFactor } from '../../interfaces/ilateral-length-factor';
import { AssetTeam } from '../asset-team';

export class LateralLengthFactorBase {
  LateralLengthFactorId: number;
  AssetTeamId: number;
  MinLateralLength: number;
  Factor: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  AssetTeam?: AssetTeam;

  constructor(item?: ILateralLengthFactor) {
    if (item) {

      this.LateralLengthFactorId = item.LateralLengthFactorId;
      this.AssetTeamId = item.AssetTeamId;
      this.MinLateralLength = item.MinLateralLength;
      this.Factor = item.Factor;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.AssetTeam = new AssetTeam(item.AssetTeam);
    }
  }
}